<template>
    <div>

    <div class="trz_leave_settings pt-4">
        <!-- <employee-public-info ></employee-public-info> -->
        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
            <template>
                <div class="row mt-4">
                    <div class="col-sm-7" >
                        <div class="border rounded p-3">
                            <div v-if="toggle_reset" class="row leave-modal-main-mobile">
                                <div class="col-sm-6">
                                    <b-form-group id="day_one-group" label="From [YYYY-MM-DD] " label-for="day_one_text">
                                        <b-input-group class="mb-3">
                                            <b-form-input v-model="day_one" type="text" disabled></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                <div class="col-sm-6">
                                    <b-form-group id="day_two-group" label="To [YYYY-MM-DD] " label-for="day_two_text">
                                        <b-input-group class="mb-3">
                                            <b-form-input v-model="day_two" type="text" disabled></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="row leave-modal-main-mobile" :class="editable">

                                <div class="col-sm-12">
                                    <!-- asfaq 8 july 2025 -->

                                    <b-form-group label="Leave Day" label-for="leave_day" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group :disabled="toggle_reset" @change="reloadType"
                                            id="leave_day-group"
                                            v-model="fdata.leave_day"
                                            :options="leaveDay"
                                            :aria-describedby="ariaDescribedby"
                                            name="leave_day"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                    <!-- asfaq 8 july 2025 -->
                                </div>

                                <div class="col-sm-6" id="leave-modal-mobile">
                                    <b-form-group id="day_one-group" label="From [YYYY-MM-DD] *" label-for="day_one_text">
                                        <b-input-group class="mb-3">
                                            <b-form-input id="day_one_text" name="day_one_text" v-model="day_one" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="updateToDate" :state="validateState('day_one_text')" aria-describedby="day_one_text-feedback" data-vv-as="From Date"></b-form-input>
                                            <b-input-group-append>
                                                <b-form-datepicker id="day_one" @context="updateToDate()" button-only right locale="en-US" v-model="day_one" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker>
                                            </b-input-group-append>
                                            <b-form-invalid-feedback id="day_one_text-feedback">{{ veeErrors.first('day_one_text') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                <div class="col-sm-6" id="leave-modal-mobile" :class="{ 'd-none': fdata.leave_day > 0 }">
                                    <b-form-group id="day_two-group" label="To [YYYY-MM-DD] *" label-for="day_two_text">
                                        <b-input-group class="mb-3">
                                            <b-form-input id="day_two_text" name="day_two_text" v-model="day_two" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="adjustValidDate" :state="validateState('day_two_text')" aria-describedby="day_two_text-feedback" data-vv-as="To Date"></b-form-input>

                                            <b-input-group-append>
                                                <b-form-datepicker id="day_two" @context="adjustValidDate()" button-only right locale="en-US" :min="min"  v-model="day_two" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker>
                                            </b-input-group-append>

                                            <b-form-invalid-feedback id="day_two_text-feedback">{{ veeErrors.first('day_two_text') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                            </div>






                            <div class='mt-2'>
                                <div class="row">
                                    <div class="col-sm-6" id="leave-modal-mobile">
                                        <b-form-group id="leave_type_id-group" label="Leave Type" class="required-field" label-for="leave_type_id">
                                            <!-- Abdullah 19-05-26 added min width 120px  -->
                                            <b-form-select :disabled="toggle_reset" id="leave_type_id" name="leave_type_id" v-model="fdata.leave_type_id" v-validate="{ required: true  }" :state="validateState('leave_type_id')" aria-describedby="leave_type_id-feedback" data-vv-as="Leave Type" style="min-width: 120px;">
                                                <b-form-select-option v-for="leave_type in leavetypes" :key="leave_type.leave_type_id" :value="leave_type.leave_type_id">{{leave_type.leave_type_title}}</b-form-select-option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="leave_type-feedback">{{ veeErrors.first('leave_type_id') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <template v-if="this.toggle_reset">
                                            <b-form-group v-if="this.ids" id="flg_status-group" label="Leave Status" class="required-field d-none" label-for="flg_status">
                                                <b-form-select id="flg_status" name="flg_status" v-model="fdata.flg_status">
                                                    <b-form-select-option v-for="leavetatus in leavestatus" :key="leavetatus.value" :value="leavetatus.value">{{leavetatus.text}}</b-form-select-option>
                                                </b-form-select>
                                            </b-form-group>
                                        </template>
                                    </div>

                                    <div class="col-sm-6" id="leave-modal-mobile">
                                        <b-form-group id="comment-group" label="Reason/Comment" class="required-field" label-for="comment">
                                            <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize v-model="fdata.comment"  v-validate="{required: true, min: 3 }" :state="validateState('comment')" aria-describedby="comment-feedback" data-vv-as="Reason/Comment"></b-form-textarea>
                                            <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-12">
                                        <b-form-group id="attachment-group" label="Attachment" label-for="attachment">
                                            <b-form-file  @change="checkFileType($event , 'attachment' , ['.jpg','.png','.gif','.pdf'])" ref="attachment"id="attachment" v-model="attachment" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_etin_scan-feedback" data-vv-as="Attachment"></b-form-file>
                                        </b-form-group>
                                    </div>

                                </div>

                                <div class="clearfix">

                                    <template v-if="show_reset == 1">
                                        <div class="float-left mr-2">
                                            <b-button v-if="toggle_reset" @click="changeDate" type="button" >Change Date / Type</b-button>
                                            <b-button v-else @click="resetChangeDate" type="button" >Reset</b-button>
                                        </div>

                                    </template>




                                    <div class="text-center"><b-button :disabled="disable_flg" @click="saveLeave()">Save</b-button></div>

                                    <div class="float-right font-italic" :class="my_class">Affected Day(s) :
                                        <span v-if="toggle_reset">{{days}}</span>
                                        <span v-else>{{dateDiff}}</span>
                                    </div>
                                    <div v-if="excess" class="float-right font-italic mx-2" :class="my_class ">Exceeded Leave!</div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!----->


                    <div class="col-sm-5">

                        <!-- Abdullah 19-05-26 commented this -->
                        <!-- <div class="card no-shadow border-0">
                            <div class="card-header table-head bg-light-blue text-center border-bottom" style="border-top-left-radius: 20px;border-top-right-radius: 20px;">
                                Other Leave Applications from this Employee
                            </div>
                            <div v-if="leaves.length == 0" class="border px-2">
                                {{blankmsg}}
                            </div>
                            <div v-else>
                                <table class="table table-responsive">
                                    <thead class="" style="">
                                        <tr class="table-head">
                                             <th class="date-0">Date of Leave (YYY-MM-DD)</th>
                                            <th>Approval Status</th>
                                            <th class="rounded-0">Leave Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="leave in leaves">
                                            <tr class="table-row hover-bg" :key="leave.leave_date">
                                                <td class="date-0">{{formatdate(leave.leave_date)}}</td>
                                                <td class=" ">{{leave.status}}</td>
                                                <td class=" ">{{ leave.leave_title }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div> -->

                        <!-- Abdullah 19-05-26 added this -->
                         <!-- Abdullah responsive added mt-3 mt-md-0  -->
                        <div class="card no-shadow border-0 mt-3 mt-md-0">
                            <div class="card-header table-head bg-light-blue text-center border-bottom" style="border-top-left-radius: 20px;border-top-right-radius: 20px;">
                                Other Leave Applications from this Employee
                            </div>

                            <!-- Abdullah 19-05-26 commented this -->
                            <!-- <div v-if="leaves.length == 0">
                                {{blankmsg}}
                            </div> -->

                            <!-- Abdullah 19-05-26 commented this -->
                            <!-- <div v-else> -->
                                <table class="table table-responsive">
                                    <thead class="" style="">
                                        <tr class="table-head">
                                             <th class="date-0">Date of Leave (YYY-MM-DD)</th>
                                            <th>Approval Status</th>
                                            <th class="rounded-0">Leave Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                         <!-- Abdullah 19-05-26 added v-if -->
                                        <template v-if="leaves.length > 0">
                                            <!-- Abdullah 19-05-26 added added v-for -->
                                            <tr class="table-row hover-bg" v-for="leave in leaves" :key="leave.leave_date">
                                                <td class="date-0">{{formatdate(leave.leave_date)}}</td>
                                                <td class=" ">{{leave.status}}</td>
                                                <td class=" ">{{ leave.leave_title }}</td>
                                            </tr>
                                        </template>

                                         <!-- Abdullah 19-05-26 added this -->
                                        <template v-else>
                                            <tr class="table-row">
                                                <td colspan="3">{{blankmsg}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            <!-- Abdullah 19-05-26 commented this -->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
                <div class="row mt-4">

                    <div class="col-sm-12">
                        <h5 class="mb-3 pb-3">Allowed Leaves</h5> <!-- Mustafijur: 20-05-2026 -->
                        <table class="table table-responsive">
                            <thead>
                                <tr class="table-head">
                                    <th>Type</th>
                                    <th>Leaves Allowed</th>
                                    <th>Carried</th>
                                    <th>Available</th>
                                    <th>Applied</th>
                                    <th>Enjoyed</th>
                                    <th>Encashed</th>
                                    <th>Remaining</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
                                    <td>{{leave_type.leave_title}}</td>

                                    <td>{{leave_type.allowed}} Days</td>

                                    <td>{{leave_type.carried}} Days</td>
                                    <td>{{leave_type.available}} Days</td>
                                    <td>{{leave_type.applied}} Days</td>
                                    <td>{{leave_type.enjoyed}} Days</td>
                                    <td>{{leave_type.encashed}} Days</td>
                                    <td>{{leave_type.remaining}} Days</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
            </template>
        </b-overlay>

    </div>
</div>
</template>
<script>

    import moment from 'moment'

    export default{

        mounted() {

        },
        props: [ 'editflg' , 'leave_type_id' , 'flg_status' , 'from' , 'to' , 'attendances_date' , 'leave_day'],
        components: {

        },
        data(){

            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth())
            minDate.setDate(minDate.getDate() + 1)
            /*const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)*/

            //minDate = moment(String(minDate)).format('YYYY-mm-dd');
            const startdate = minDate

            //////////////////////////////
            var startDate = '';
            var endDate = '';
            //var today = new Date();
            if ((today.getMonth() + 1) <= 6)
            {
                startDate = (today.getFullYear() - 1) + '-07-1';
                endDate = (today.getFullYear()) + '-06-30';
            }
            else
            {
                startDate = (today.getFullYear()) + '-07-1';
                endDate = (today.getFullYear() + 1) + '-06-30';
            }
            //////////////////////////////

            return {

                startDate : startDate,
                endDate : endDate,
                ///////////////////////


                min: minDate,
                //max: maxDate,
                showoverlay : false,


                //day_one: moment(String(startdate)).format('YYYY-MM-DD') ,
                //day_two: moment(String(startdate)).format('YYYY-MM-DD') ,

                day_one: '' ,
                day_two: '' ,


                fdata : {leave_day: this.leave_day ?? 0, day_one: this.day_one , day_two:this.day_two, days:null , leave_type_id:null , flg_status:0, comment:null},
                leave_details : {},
                attachment : null,

                company_id : 0 ,

                ce : true,

                my_class : '',

                blankmsg : 'Fetching data..',

                holidays : [],
                leaves : [],
                holidays_date_arr : [],
                leave_limit : [],
                leave_available : [],
                disable_flg : false,

                week_holidays : [6],
                all_week_holidays : [6],
                week_start_day : 7,
                count_options: [
                            { value: 1, text: '1' },
                            { value: 2, text: '2' },
                            { value: 3, text: '3' },
                            { value: 4, text: '4' },
                            { value: 5, text: '5' },
                            { value: 6, text: '6' },
                            { value: 7, text: '7' },
                            { value: 8, text: '8' },
                            { value: 9, text: '9' },
                        ],


                options: [
                    { text: 'Friday', value: '5' },
                    { text: 'Saturday', value: '6' },
                    { text: 'Sunday', value: '0' },
                    { text: 'Monday', value: '1' },
                    { text: 'Tuesday', value: '2' },
                    { text: 'Wednesday', value: '3' },
                    { text: 'Thursday', value: '4' }
                ],
                //1 for casual leave, 2 for sick leave, 3 for annual leave, 4 for unpaid leave, 5 for compaensatory leave
                leavetypes: [],

                leavestatus: [
                    { text: 'Applied', value: '0' },
                    { text: 'Approved', value: '1' },
                    { text: 'Declined', value: '2' },
                ],

                leaveDay: [
                    { text: 'Full Day', value: '0' },
                    { text: 'First Half', value: '1' },
                    { text: 'Second Half', value: '2' },
                ],

                fake : 0,
                days : 0,
                ids : 0,
                show_reset : 0,
                toggle_reset : false,
                editable : '',

                off_day_on_leave : 0,
                skip_days: {},
                can_exceed:[],
            }
        },
        methods:{

            // 8 july 2025
            reloadType:function()
            {
                var x = this.fdata.leave_day;



                if(x > 0)
                {
                    this.fdata = {leave_day:x, day_one: this.day_one , day_two:this.day_one, days:null , leave_type_id:null , flg_status:0, comment:null};
                    this.day_two = this.day_one;

                }

                this.getLeaveTypeByLeavePolicy(x);

            },
            getLeaveTypeByLeavePolicy: function(f=0)
            {
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/front/leave/type/by/leave/policy?f='+f).then(function(response){

                    this.leavetypes = response.data;

                    if(this.leavetypes.length > 0)
                        this.show_warning = false;
                    else
                        this.show_warning = true;

                }.bind(this));
            },
            // 8 july 2025

            fetchLeavesByRangeTypeStatus: function()
            {
                this.day_one = this.from;
                this.day_two = this.to;
                this.fdata.leave_type_id = this.leave_type_id;

                // to set the to date without depending on from date
                setTimeout(function () { this.fake = 0; }.bind(this), 1000);



                let formData = new FormData();
                //formData.append('employee_id', employee_id);
                formData.append('leave_type_id', this.leave_type_id);
                formData.append('flg_status', this.flg_status);
                formData.append('from', this.from);
                formData.append('to', this.to);

                axios.post(this.$api_url+'/front/employee/leaves/range', formData)
                    .then(function(response){

                        //console.log(response.data);
                        this.fdata.comment = response.data.comment;
                        this.fdata.flg_status = response.data.flg_status;
                        this.days = response.data.days;
                        this.ids = response.data.ids;
                        this.show_reset = 1;
                        this.editable = 'd-none';


                    //this.$validator.reset();
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.serverError(error);
                });
            },
            resetChangeDate : function()
            {
                this.showoverlay = true;
                this.toggle_reset = !this.toggle_reset;

                this.getEmployeeLeaveSettings();
                this.getLeaveTypeByLeavePolicy();
                this.getHoliDays();
                this.getLeaves();

                if(this.editflg == 1)
                {
                    this.fake = 1;
                    this.fetchLeavesByRangeTypeStatus();
                }

                setTimeout(function () { this.showoverlay = false; }.bind(this), 1000);

            },
            changeDate : function()
            {
                this.showoverlay = true;
                this.editable = '';

                this.toggle_reset = !this.toggle_reset;
                this.fdata.flg_status = 0;
                //this.leave_available.forEach(element => {
                this.leave_available.forEach((element, index) => {

                    //console.log(element);
                    if(element.leave_type_id == this.leave_type_id)
                    {
                        this.leave_available[index].remaining_days = this.leave_available[index].remaining_days + this.days;
                        this.leave_limit[this.leave_type_id] = this.leave_limit[this.leave_type_id] + this.days;
                    }


                    this.day_one = this.from;
                    this.fdata.leave_type_id = this.leave_type_id;
                    // to set the to date without depending on from date
                    setTimeout(function () { this.fake = 0; }.bind(this), 1000);
                    this.day_two = this.to;

                });

                this.showoverlay = false;

            },

            dateDisabled(ymd, date) {
                const x = moment(String(date)).format('YYYY-MM-DD');
                const weekday = date.getDay();
                const day = date.getDate();
                return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
            },
            updateToDate:function()
            {
                if(this.fake == 1)return;

                this.min = this.day_one;

                // move leave start date to preceeding off day
                if(this.off_day_on_leave == 2)
                {
                    this.pushBackStartDate(this.day_one);
                }
                else
                    this.day_two = this.day_one;
            },
            pushBackStartDate:function(x)
            {
                let m = moment(x);
                m.add(-1, 'days');
                if(this.skip_days.includes(m.format('YYYY-MM-DD')))
                {
                    this.day_two = '';
                    this.day_one = m.format('YYYY-MM-DD');
                    this.pushBackStartDate(this.day_one);
                }

            },
            checkValidDate:function()
            {
                if(moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
                    this.updateToDate();
            },
            adjustValidDate:function()
            {
                //this.checkOffDayOnLeave();
                if(moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
                    this.day_two = this.day_one;

                else if(moment(this.day_two).isAfter(moment(this.endDate).format('YYYY-MM-DD')))
                {
                    this.day_two = this.day_one;
                }
                else
                {
                    // move leave end date to succeding off day
                    if(this.off_day_on_leave == 2)
                    {
                        let n = moment(this.day_two);
                        n.add(1, 'days');
                        if(this.skip_days.includes(n.format('YYYY-MM-DD')))
                        {
                            this.day_two = n.format('YYYY-MM-DD');
                            this.adjustValidDate();
                        }
                    }
                }
            },
            formatdate:function(x)
            {
                return moment(x).format('YYYY-MM-DD');
            },
            checkGaterDate(x)
            {
                return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
            },
            getEmployeeLeaveSettings:function()
            {

                axios.get(this.$api_url+'/front/employee/leave/settings' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.company_id =  response.data.company_id;
                        this.all_week_holidays = response.data.week_holidays;
                        this.week_holidays = response.data.week_holidays.split(',');
                        this.week_start_day =  response.data.week_start_day;

                        this.off_day_on_leave = response.data.off_day_on_leave;
                        this.skip_days = response.data.skip_days.split(',');
                    }

                }.bind(this));

            },
            // getLeaveTypeByLeavePolicy: function()
            // {
            //     if(!this.checkNet()) return false;

            //     axios.get(this.$api_url+'/front/leave/type/by/leave/policy' , {
            //         params: {

            //         }
            //     }).then(function(response){

            //         this.leavetypes = response.data;

            //     }.bind(this));
            // },
            updateLeave : function(x)
            {
                //leave_details
                axios.get(this.$api_url+'/front/employee/leave/details?id='+x , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    //console.log(response.data);

                    this.leave_details = response.data;

                }.bind(this));
                this.$bvModal.show('bv-modal-leave');
            },
            onSubmitLeaveUpdate : function()
            {
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.leave_details))
                {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);

                }
                axios.post(this.$api_url+'/front/employee/leave/details', formData,)
                            .then(function (response)
                            {
                                this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                this.getLeaves();
                                this.$bvModal.hide('bv-modal-leave');
                                let childdata = {leave_limit_start:'',leave_limit_end:''};
                                this.$emit('childToParent',childdata);

                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });
            },
            getHoliDays:function()
            {
                axios.get(this.$api_url+'/front/company/holidays' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.holidays = response.data.holidays;
                        this.holidays_date_arr = response.data.holidays_date_arr.split(',').map(function(item){ return item;});
                    }

                }.bind(this));

            },
            getLeaves:function()
            {

                axios.get(this.$api_url+'/front/employee/leaves' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        // Abdullah 19-05-26 commented this
                        // this.leaves = response.data.leave_data;

                        // Abdullah 19-05-26 commented this
                        const leave_data = response.data.leave_data;
                        this.leaves = Object.values(leave_data || {});
                        // Abdullah 19-05-26 commented this upto this
                        this.leave_limit = response.data.limit;

                        this.leave_available = response.data.available;
                        this.can_exceed = response.data.can_exceed;

                        this.leave_available.forEach((element, index) => {

                            this.leave_available[index].available = this.leave_available[index].allowed +  this.leave_available[index].carried;

                        });

                        let range = response.data.range;

                        if(this.leaves.length == 0)
                        {
                            this.blankmsg = 'Looks like no leave applied for the employee yet.';

                        }

                        // let childdata = {leave_limit_start:range.leave_limit_start_date,leave_limit_end:range.leave_limit_end_date};
                        // this.$emit('childToParent',childdata);

                        this.startDate =  response.data.range.leave_limit_start_date;
                        this.endDate =  response.data.range.leave_limit_end_date;
                    }

                }.bind(this));

            },
            saveLeave:function()
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    let currentObj = this;
                    let formData = new FormData();

                    if(this.editflg == 1)
                        formData.append('ids', this.ids);

                    if(!this.toggle_reset)
                        formData.append('removeids', this.ids);

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    if(this.attachment)
                    {
                        formData.append('attachment', this.attachment);
                    }


                    axios.post(this.$api_url+'/front/employee/leaves', formData,)
                                .then(function (response)
                                {

                                    if(response.data.status)
                                    {

                                        //this.leaves = response.data.leave_data;
                                        //this.leave_limit = response.data.limit;
                                        //this.getLeaves();

                                        this.$bvToast.toast('Saved!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });

                                        let childdata = {leave_limit_start:'',leave_limit_end:''};
                                        setTimeout(function () { this.$emit('childToParent',childdata); }.bind(this), 1000);
                                    }
                                    else
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                                title: `Warning`,
                                                variant: 'warning',
                                                solid: true
                                            });
                                    }


                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });

                });
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            fetchDateDisabled()
            {
                return this.week_holidays;
            },
            checkValidDate(date)
            {

                if (this.startDate <= date && date <= this.endDate) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        created: function(){

            this.getEmployeeLeaveSettings();
            this.getLeaveTypeByLeavePolicy();
            this.getHoliDays();
            this.getLeaves();

            if(this.editflg == 1)
            {
                this.fake = 1;
                this.fetchLeavesByRangeTypeStatus();

                this.toggle_reset = true;
            }
            else if(this.attendances_date != null)
            {

                this.fdata.day_one = this.attendances_date;
                this.day_one = this.attendances_date;




            }
        },
        computed:
        {

            dateDiff()
            {
                //fdata : {day_one:null , day_two:null, days:null , details:null},
                this.disable_flg = false;

                var day_one = moment(this.day_one);
                var day_two = moment(this.day_two);

                let days = 0;

                this.fdata.day_one = moment(String(this.day_one)).format('YYYY-MM-DD');
                this.fdata.day_two = moment(String(this.day_two)).format('YYYY-MM-DD');

                if(!this.checkValidDate(this.fdata.day_one))
                {
                    this.disable_flg = true;
                    this.my_class = 'danger';

                    if(this.day_one == '')
                        return 'Empty Date!';
                    else
                        return 'Wrong Leave Year!';
                }



                if(this.day_one === this.day_two)
                {
                    this.fdata.days = 1;
                    //return 1;
                    days = 1;
                }
                else
                {
                    if(this.off_day_on_leave == 1)
                    {
                        days = 1;
                        for (var m = moment(this.day_one); m.isBefore(this.day_two); m.add(1, 'days'))
                        {
                            if(this.skip_days.includes(m.format('YYYY-MM-DD')))
                                continue;
                            ++days;
                        }
                    }
                    else
                    {
                        days = day_two.diff(day_one, 'days') // 1
                        ++days;
                    }
                }



                if(days > 0)
                {

                    this.fdata.days = days;

                    if(this.can_exceed.includes(this.fdata.leave_type_id))
                    {
                        //alert('can be exceed');
                        if(days > this.leave_limit[this.fdata.leave_type_id])
                        {
                            this.disable_flg = false;

                            this.my_class = 'danger';

                            this.excess = true;

                            return days;
                        }
                        else
                        {
                            this.excess = false;
                            this.disable_flg = false;
                            this.my_class = '';
                            return days;
                        }
                    }
                    else
                    {
                        if(days > this.leave_limit[this.fdata.leave_type_id])
                        {
                            this.disable_flg = true;

                            this.my_class = 'danger';

                            return 'Limit Exceed!';
                        }
                        else
                        {
                            this.excess = false;
                            this.disable_flg = false;
                            this.my_class = '';
                            return days;
                        }
                    }
                }
                else if(days < 0)
                {
                    this.fdata.days = 0;
                    this.disable_flg = true;
                    return 'Invalid Date Range';
                }

            },
            fetchStartWeekday()
            {
                return this.week_start_day;
            },

        }
    }
</script>
<style >
    .trz_leave_settings .custom-select{width: auto !important;}
    .trz_list li{margin-top:5px;}
    .danger{color:red;}
</style>
